module.exports = __webpack_public_path__ + "img/language-en.2dc97293.png";